module.exports = __webpack_public_path__ + "static/media/LT2-BG1.cd9c4689.jpg";